export function truncateFileNameAndType(fileNameStr) {
  return [
    fileNameStr.substring(0, fileNameStr.lastIndexOf('.')),
    fileNameStr.substring(fileNameStr.lastIndexOf('.'), fileNameStr.lastIndex),
  ];
}

export function joinFileType(fileName, fileExt) {
  return `${fileName}${fileExt}`;
}

export function truncateFileNamefunction(fullStr, strLen, separator) {
  // When a file name is long, truncate the file name in the middle
  if (fullStr.length <= strLen) return fullStr;
  separator = separator || '...';
  var sepLen = separator.length,
    charsToShow = strLen - sepLen,
    frontChars = Math.ceil(charsToShow / 2),
    backChars = Math.floor(charsToShow / 2);
  return fullStr.substr(0, frontChars) + separator + fullStr.substr(fullStr.length - backChars);
}

export function generateTrucatedFileName(fileNameFullStr) {
  let [fileName, fileType] = truncateFileNameAndType(fileNameFullStr);
  let truncatedFileName = truncateFileNamefunction(fileName, 25);
  return joinFileType(truncatedFileName, fileType);
}
